import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SubmissionError } from 'redux-form'
import { withRouter } from 'react-router-dom'

import { fetchOrganizations } from 'ducks/organizations'
import { requestApp } from 'utils/io'

import { getMetrics } from 'ducks/metrics'
import { getDefaultDatasource } from 'ducks/apps/datasources'
import { saveSubscription, fetchSubscription } from 'ducks/billing'
import { CardElement } from '@stripe/react-stripe-js'
import Modal from '../Modal'
import Button from '../Button'
import SignupForm from './SignupForm'
import {
  getAnnualToggle,
  getPaymentRouteType,
  getUpdateCardFlag,
  getUpdatePaymentSettingsFlag,
  setPlanSelectedFlag,
  setSelectedPlanValue,
  setUpdateCardFlag,
} from '../../../ducks/trialWarning'
import paymentSuccessLogo from '../Icon/icons/Teal_Check_Mark.gif'
import { withStripePromise } from './LoadStripe'

class TrialModal extends Component {
  state = {
    success: false,
  }

  fetchData = async () => {
    const { fetchOrganizations, match } = this.props
    const { appId } = match.params
    await requestApp(appId)
    fetchOrganizations()
  }

  handleSubmit = async values => {
    const {
      stripe,
      elements,
      saveSubscription,
      organizationId,
      initialValues,
      setPlanSelectedFlag,
      setSelectedPlanValue,
      setUpdateCardFlag,
      fetchSubscription,
    } = this.props

    const { annual } = initialValues

    let {
      plan: planType,
      coupon,
      name,
      address_country,
      address_zip,
      address_city,
      address_line1,
    } = values

    const subscription = (await fetchSubscription(organizationId)).value.data
    let { paymentMethodId } = subscription || null

    const { configured } = subscription || null

    const cardElement = elements.getElement(CardElement)

    address_country = address_country && address_country.value

    let paymentMethodError

    if (cardElement) {
      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name,
          address: {
            country: address_country,
            postal_code: address_zip,
            city: address_city,
            line1: address_line1,
          },
        },
      })

      if (error) {
        paymentMethodError = error
      }

      paymentMethodId = paymentMethod && paymentMethod.id
    }

    if (paymentMethodId || configured) {
      try {
        const response = await saveSubscription(organizationId, {
          coupon,
          planType,
          paymentMethodId,
          annual,
        })

        const paymentIntent = response.value.data.paymentIntent || null

        if (
          paymentIntent &&
          (paymentIntent.status === 'requires_action' ||
            paymentIntent.status === 'requires_payment_method')
        ) {
          await this.handleCardSetupRequired(
            paymentIntent,
            paymentMethodId,
            organizationId
          )
        }

        if (planType === 'pro' || planType === 'individual') {
          if (window.ga) {
            window.ga('send', {
              hitType: 'event',
              eventCategory: 'button',
              eventAction: 'click',
              eventLabel: 'Payment Made',
              eventValue: 50,
            })
          }
        }

        if (planType === 'business' || planType === 'launch') {
          if (window.ga) {
            window.ga('send', {
              hitType: 'event',
              eventCategory: 'button',
              eventAction: 'click',
              eventLabel: 'Payment Made',
              eventValue: 200,
            })
          }
        }

        setPlanSelectedFlag(false)
        setSelectedPlanValue('')
        setUpdateCardFlag(false)
        this.handleSuccess(planType)
      } catch (err) {
        const { response, message, errors } = err

        const errorMessage =
          errors?._error ||
          response?.data?.error ||
          message ||
          'An unknown error occurred'

        throw new SubmissionError({ _error: errorMessage })
      }
    } else {
      console.error('ERROR SAVING SUBSCRIPTION:', paymentMethodError)

      throw new SubmissionError({
        _error: paymentMethodError.message,
      })
    }
  }

  handleCardSetupRequired = async (paymentIntent, paymentMethodId) => {
    const { stripe } = this.props

    return stripe
      .confirmCardPayment(paymentIntent.client_secret, {
        payment_method: paymentMethodId,
      })
      .then(async result => {
        if (result.error) {
          const errorMessage =
            (result.error.code && result.error.message) ||
            'Error in confirm card pÎayment'

          throw new SubmissionError({ _error: errorMessage })
        }
      })
      .catch(async error => {
        const errMessage = error.errors._error || error.message

        throw new SubmissionError({ _error: errMessage })
      })
  }

  handleSuccess = async planType => {
    const { organizationId } = this.props

    try {
      await saveSubscription(organizationId, {
        planType,
        configureExistingSubscription: true,
      })

      const { forceRefresh } = this.props
      forceRefresh()
      this.fetchData()
      this.setState({ success: true })
    } catch (err) {
      const errMessage = err.errors._error || err.message
      throw new SubmissionError({ _error: errMessage })
    }
  }

  renderForm() {
    const {
      onClose,
      metrics,
      datasource,
      onDowngrade,
      initialValues,
      onClickBackChangePlan,
      organizationId,
    } = this.props

    return (
      <SignupForm
        onSubmit={this.handleSubmit}
        onCancel={onClose}
        initialValues={initialValues}
        metrics={metrics}
        datasource={datasource}
        onDowngrade={onDowngrade}
        onClickBackChangePlan={onClickBackChangePlan}
        applyCoupon={this.handleCoupon}
        organizationId={organizationId}
      />
    )
  }

  renderSuccess() {
    const { onClose } = this.props

    return (
      <Modal size="sm">
        <Modal.Content style={{ textAlign: 'center' }}>
          <Modal.Container>
            <img
              className="paymentSuccessLogo"
              src={paymentSuccessLogo}
              alt=""
            />
            <h1 className="trial-signup-success-message">
              Payment Successful!
            </h1>
            <p>You can edit your plan in your Account Settings at any time.</p>
          </Modal.Container>
        </Modal.Content>
        <Modal.Actions>
          <Button large onClick={onClose}>
            Done
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

  renderContent() {
    const { success } = this.state

    if (success) {
      return this.renderSuccess()
    }

    return this.renderForm()
  }

  render() {
    const { onClose, paymentRouteType } = this.props

    if (paymentRouteType === 'upgrade') {
      return (
        <Modal size="lg" scrolling onClose={onClose}>
          {this.renderContent()}
        </Modal>
      )
    } else {
      return this.renderContent()
    }
  }
}

const mapStateToProps = (state, { appId }) => ({
  metrics: getMetrics(state, appId),
  datasource: getDefaultDatasource(state, appId),
  updateCardFlag: getUpdateCardFlag(state),
  updatePaymentSettings: getUpdatePaymentSettingsFlag(state),
  annual: getAnnualToggle(state),
  paymentRouteType: getPaymentRouteType(state),
})

const connected = connect(mapStateToProps, {
  fetchSubscription,
  saveSubscription,
  fetchOrganizations,
  setPlanSelectedFlag,
  setSelectedPlanValue,
  setUpdateCardFlag,
})(withStripePromise(TrialModal))

export default withRouter(connected)
